import Modulos from '@/classes/enums/Modulos'
import store from '@/store'
const hasVerifactuModule = store.getters['auth/hasVerifactuModule']

export default [
  {
    path: 'dashboard/:id?',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: { registerNavFromMenu: true }
  },
  {
    path: 'financialdashboard',
    name: 'financialdashboard',
    redirect: { name: 'financialdashboard/general' },
  },
  {
    path: 'financialdashboard/general/:id?',
    name: 'financialdashboard/general',
    component: () => import('@/views/dashboard/GeneralFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false }
  },
  {
    path: 'financialdashboard/issued/:id?',
    name: 'financialdashboard/issued',
    component: () => import('@/views/dashboard/IssuedFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false, modules: [[Modulos.EMISION_FACTURAS]] }
  },
  {
    path: 'financialdashboard/received/:id?',
    name: 'financialdashboard/received',
    component: () => import('@/views/dashboard/ReceivedFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false, modules: [[Modulos.RECEPCION_FACTURAS]] }
  },
  {
    path: 'financialdashboard/fiscal/:id?',
    name: 'financialdashboard/fiscal',
    redirect: { name: hasVerifactuModule ? 'financialdashboard/verifactu' : 'financialdashboard/taxes' },
  },
  {
    path: 'financialdashboard/verifactu/:id?',
    name: 'financialdashboard/verifactu',
    component: () => import('@/views/dashboard/VerifactuFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false, modules: [[Modulos.VERIFACTU]] }
  },
  {
    path: 'financialdashboard/taxes/:id?',
    name: 'financialdashboard/taxes',
    component: () => import('@/views/dashboard/TaxesFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false }
  },
  {
    path: 'financialdashboard/warning/:id?',
    name: 'financialdashboard/warning',
    component: () => import('@/views/dashboard/WarningFinancialDashboard.vue'),
    meta: { secondaryMenu: 'financialDashboard', registerNavFromMenu: false }
  },
]
